export interface FetchResponse<T> {
  data: T;
  statusCode?: number;
  error?: {
    message: string;
    statusCode: number;
    properties?: {
      property: string;
      errorMessages: string[];
    }[];
  };
}

export type ActionHandlerOptions = {
  redirect?: string;
  revalidate?: string;
  token?: string | null;
};

export interface BaseModel {
  id?: string;
  createdDate?: string;
  updatedDate?: string;
}

export interface PaginationResponse<T> {
  data: T[];
  total: number;
  page: number;
  pageCount: number;
  error?: {
    message: string;
    statusCode?: number;
  };
}

export enum OrderDirectionEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export enum AppContextEnum {
  MARKETPLACE = "MARKETPLACE",
  STORE_MANAGEMENT = "STORE_MANAGEMENT",
}

export interface CrudQuery {
  sort?: {
    field: string;
    order: OrderDirectionEnum;
  }[];
  filters?: {
    field: string;
    value?: string | boolean | (string | number)[];
    fn?: string;
    start?: number | Date;
    end?: number | Date;
  }[];
  search?: string;
  pagination: {
    page: number;
    total: number;
  };
}
